import {
  useQuery,
  UseQueryResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { requestV3 } from 'Features/Auth/axios-client'
import { AllocationUpdateInterface } from './Allocations.types'

interface FetchAllocationArgs {
  projectId: string
  scenarioId: string
}

interface UpdateAllocationArgs extends FetchAllocationArgs {
  data: AllocationUpdateInterface[]
}
// fetch product allocation.
const fetchProductAllocation = async (
  projectId: string,
  scenarioId: string
) => {
  const { data } = await requestV3({
    url: `/product-allocation?project_id=${projectId}&scenario_id=${scenarioId}`,
  })
  return data
}

export const useProductAllocation = ({
  projectId,
  scenarioId,
}: FetchAllocationArgs) => {
  return useQuery({
    queryKey: ['productAllocation', projectId, scenarioId],
    queryFn: () => fetchProductAllocation(projectId, scenarioId),
    select: (data) => data,
    refetchOnWindowFocus: false,
    gcTime: Infinity,
  })
}

// Update product allocation:
const updateProductAllocation = async ({
  projectId,
  scenarioId,
  data,
}: UpdateAllocationArgs) => {
  const { data: response } = await requestV3({
    url: `/product-allocation?project_id=${projectId}&scenario_id=${scenarioId}`,
    method: 'PUT',
    data,
  })
  return response
}

export const useUpdateProductAllocation = (
  onSuccess: () => void,
  onError: () => void
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateProductAllocation,
    onSuccess: (_, variables: UpdateAllocationArgs) => {
      queryClient.invalidateQueries({
        queryKey: [
          'productAllocation',
          variables.projectId,
          variables.scenarioId,
        ],
      })
      onSuccess()
    },
    onError,
  })
}
// Compare this snippet from src/features/Projects/Scenarios/EditSettings/FactorySettings/Allocations.data.ts:
